//Images
import TermsConditionsDocument from "../../../images/TermsConditionsDocument.png"
import { ReactComponent as ExternalLinkIcon } from "../../../images/TermsConditionsExternalLink.svg"
import { ReactComponent as ExternalLinkIconOpened } from "../../../images/TermsConditionsExternalLinkOpened.svg"

//CSS
import "./TermsConditionsListItem.css"
export default function TermsConditionsListItem({
    id,
    onClick,
    document,
    isOpened
}) {
    return (
        <div className="TermsConditionsListItem">
            <img className="TermsConditionsListItem-img-right" src={TermsConditionsDocument} />
            <span>{document}</span>
            {(isOpened ? (<ExternalLinkIconOpened onClick={() => { onClick(id) }} className={"TermsConditionsListItem-img-left"} />) : (<ExternalLinkIcon onClick={() => { onClick(id) }} className="TermsConditionsListItem-img-left" />))}
        </div>
    );
}